module.exports = __webpack_public_path__ + "img/滑石粉系滑石经精选净制、粉碎、干燥制成。主产....91cc07d6.jpg";